import { lazy } from 'react';

const List = lazy(() => import('./list'));

export { List };
